export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig();
    const gtmId = config.public.gtm?.id;

    if (process.client && gtmId) {
        (function(w, d, s, l, i) {
            w[l] = w[l] || []
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
            const f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l !== 'dataLayer' ? '&l=' + l : ''
            j.async = true
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + encodeURIComponent(i) + dl
            f.parentNode?.insertBefore(j, f)
        })(window, document, 'script', 'dataLayer', gtmId)
    }
})
